import React from "react";
import { Link } from "react-router-dom";

// Section C (admin-only): the landing page at /admin — lets the admin
// choose which part of the site's content they want to manage.
function AdminDashboardPage() {
  // Only sign-out control in the admin panel now that /profile is gone.
  // Clearing storage and reloading re-mounts AdminRoute, which shows the
  // login form again since there's no more token to find.
  function handleLogout() {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    window.location.href = "/admin";
  }

  return (
    <div className="admin-page">
      <Link to="/" className="back-link">
        ← بازگشت به سایت
      </Link>

      <div className="admin-page-header">
        <h1>پنل مدیریت</h1>
        <div className="admin-page-header-actions">
          <Link to="/admin/admins/new" className="admin-logout-button">
            افزودن مدیر جدید
          </Link>
          <Link to="/admin/change-password" className="admin-logout-button">
            تغییر رمز عبور
          </Link>
          <button type="button" className="admin-logout-button" onClick={handleLogout}>
            خروج
          </button>
        </div>
      </div>

      <div className="pub-grid">
        <Link to="/admin/articles" className="pub-card-link">
          <article className="feature-card pub-card">
            <span className="corner corner-tr" />
            <span className="corner corner-tl" />
            <span className="corner corner-br" />
            <span className="corner corner-bl" />
            <h2>مقاله‌های صفحهٔ اصلی</h2>
            <p>ایجاد، ویرایش و حذف مقاله‌هایی که در صفحهٔ اصلی نمایش داده می‌شوند.</p>
          </article>
        </Link>

        <Link to="/admin/issues" className="pub-card-link">
          <article className="feature-card pub-card">
            <span className="corner corner-tr" />
            <span className="corner corner-tl" />
            <span className="corner corner-br" />
            <span className="corner corner-bl" />
            <h2>شماره‌های دریچه</h2>
            <p>بارگذاری و حذف جلدهای آرشیو شماره‌های نشریه در صفحهٔ «نشریه‌ها».</p>
          </article>
        </Link>

        <Link to="/admin/featured" className="pub-card-link">
          <article className="feature-card pub-card">
            <span className="corner corner-tr" />
            <span className="corner corner-tl" />
            <span className="corner corner-br" />
            <span className="corner corner-bl" />
            <h2>کارت‌های منتخب صفحهٔ اصلی</h2>
            <p>انتخاب سه کارتی که از میان کارت‌های نشریه‌ها در صفحهٔ اصلی نمایش داده می‌شوند.</p>
          </article>
        </Link>

        <Link to="/admin/pinned-home" className="pub-card-link">
          <article className="feature-card pub-card">
            <span className="corner corner-tr" />
            <span className="corner corner-tl" />
            <span className="corner corner-br" />
            <span className="corner corner-bl" />
            <h2>کارت‌های نشریه/شماره در «مقاله‌های منتخب»</h2>
            <p>افزودن کارت‌هایی از هر نشریه یا هر شمارهٔ دریچه به ردیف «مقاله‌های منتخب» صفحهٔ اصلی، در کنار مقاله‌های خودکار.</p>
          </article>
        </Link>
      </div>
    </div>
  );
}

export default AdminDashboardPage;
